/* NOELVA produktsida: galleri, paket, färg/storlek, storleksguide, varukorg, fast köpknapp. */
(function(){
  var root=document.querySelector('[data-pdp-main]'); if(!root) return;
  var variants=JSON.parse(root.querySelector('[data-variants]').textContent||'[]');
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var label=root.getAttribute('data-btn-label')||'Lägg i varukorgen – [pris] kr';

  /* Galleri */
  var track=root.querySelector('[data-track]'), thumbs=root.querySelectorAll('[data-thumb]'), dots=root.querySelector('[data-dots]');
  var n=track.children.length;
  for(var d=0;d<n;d++){var s=document.createElement('span');dots.appendChild(s);}
  function go(i){i=(i+n)%n;track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});}
  function cur(){return Math.round(track.scrollLeft/Math.max(1,track.clientWidth));}
  function mark(){var c=cur();thumbs.forEach(function(t,i){t.setAttribute('aria-current',i===c?'true':'false');});Array.prototype.forEach.call(dots.children,function(x,i){x.classList.toggle('is-on',i===c);});}
  root.querySelector('[data-prev]').addEventListener('click',function(){go(cur()-1);});
  root.querySelector('[data-next]').addEventListener('click',function(){go(cur()+1);});
  thumbs.forEach(function(t){t.addEventListener('click',function(){go(+t.getAttribute('data-thumb'));});});
  track.addEventListener('scroll',mark,{passive:true}); mark();

  /* Paket */
  var bundles=root.querySelectorAll('[data-bundle]');
  function active(){return root.querySelector('[data-bundle][aria-checked="true"]')||bundles[0];}
  function pickBundle(b){bundles.forEach(function(x){x.setAttribute('aria-checked',x===b?'true':'false');});refresh();}
  bundles.forEach(function(b){
    b.addEventListener('click',function(){pickBundle(b);});
    b.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){e.preventDefault();pickBundle(b);}});
  });

  /* Färg och storlek: ett val för alla trosor */
  var pick=root.querySelector('[data-pick]');
  function sel(attr){var x=pick.querySelector('['+attr+'][aria-checked="true"]');return x?x.getAttribute(attr):null;}
  pick.addEventListener('click',function(e){
    var p=e.target.closest('.pdp-pill'); if(!p) return;
    var attr=p.hasAttribute('data-color')?'data-color':'data-size';
    pick.querySelectorAll('['+attr+']').forEach(function(x){x.setAttribute('aria-checked',x===p?'true':'false');});
    if(attr==='data-color') pick.querySelector('[data-color-label]').textContent=p.getAttribute('data-color');
    /* Följer med till blanda-raderna som inte ändrats för hand */
    mix.querySelectorAll('.pdp-item').forEach(function(r){if(!r.dataset.touched){r.querySelector('[data-opt="'+(attr==='data-color'?'color':'size')+'"]').value=p.getAttribute(attr);}});
    refresh();
  });

  /* Blanda */
  var mix=root.querySelector('[data-mix]'), mixBtn=root.querySelector('[data-mix-toggle]');
  mixBtn.addEventListener('click',function(){var open=mix.hidden;mix.hidden=!open;mixBtn.setAttribute('aria-expanded',open?'true':'false');mixBtn.textContent=open?'Samma färg och storlek på alla':'Vill du blanda färger eller storlekar?';refresh();});
  mix.addEventListener('change',function(e){var r=e.target.closest('.pdp-item');if(r)r.dataset.touched='1';refresh();});

  function find(c,s){for(var i=0;i<variants.length;i++){var v=variants[i];if((v.option1===c&&v.option2===s)||(v.option1===s&&v.option2===c))return v;}return null;}
  function lines(){
    var b=active(), qty=+b.dataset.qty, out=[];
    if(!mix.hidden){
      mix.querySelectorAll('.pdp-item').forEach(function(r,i){if(i<qty)out.push([r.querySelector('[data-opt="color"]').value,r.querySelector('[data-opt="size"]').value]);});
    } else { for(var i=0;i<qty;i++) out.push([sel('data-color'),sel('data-size')]); }
    return out;
  }

  /* Knapparna visar paketets pris */
  var btn=root.querySelector('[data-atc]'), msg=root.querySelector('[data-msg]');
  var sticky=root.querySelector('[data-sticky]'), sbtn=root.querySelector('[data-sticky-btn]');
  var sname=root.querySelector('[data-sticky-name]'), ssel=root.querySelector('[data-sticky-sel]');
  function refresh(){
    var b=active(), qty=+b.dataset.qty;
    mix.querySelectorAll('.pdp-item').forEach(function(r,i){r.hidden=i>=qty;});
    var t=label.replace('[pris]',b.dataset.price);
    btn.textContent=t; sbtn.textContent=t;
    /* Kort nog för en rad i den fasta knappen på 390 px (Daris 15 okt: «Köp 1, få 1 grati…» kapades) */
    sname.textContent=b.querySelector('.pdp-bundle__name').textContent.replace(/ gratis$/,'');
    ssel.textContent=qty+' st · '+(mix.hidden?(sel('data-color')+' · '+sel('data-size')):'blandat');
  }
  refresh();

  function buy(button){
    var items={}, ok=true;
    lines().forEach(function(l){var v=find(l[0],l[1]);if(!v){ok=false;return;}items[v.id]=(items[v.id]||0)+1;});
    if(!ok){msg.textContent='Den kombinationen finns inte. Välj en annan färg eller storlek.';return;}
    var list=Object.keys(items).map(function(id){return {id:+id,quantity:items[id]};});
    btn.disabled=true; sbtn.disabled=true; msg.textContent='';
    /* Lägger till och öppnar varukorgspanelen (Daris 5 okt kväll), i stället för att gå direkt till kassan. */
    fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:list})})
      .then(function(r){if(!r.ok)throw r;return r.json();})
      .then(function(){btn.disabled=false;sbtn.disabled=false;
        if(window.NoelvaCart)window.NoelvaCart.open();else window.location.href=base+'cart';})
      .catch(function(){btn.disabled=false;sbtn.disabled=false;msg.textContent='Något gick fel. Försök igen.';});
  }
  btn.addEventListener('click',function(){buy(btn);});
  sbtn.addEventListener('click',function(){buy(sbtn);});

  /* Storleksguide */
  var sheet=root.querySelector('[data-size-sheet]');
  function openS(o){sheet.classList.toggle('is-open',o);sheet.setAttribute('aria-hidden',o?'false':'true');document.documentElement.style.overflow=o?'hidden':'';}
  root.querySelectorAll('[data-open-size]').forEach(function(x){x.addEventListener('click',function(){openS(true);});});
  sheet.querySelectorAll('[data-close-size]').forEach(function(x){x.addEventListener('click',function(){openS(false);});});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')openS(false);});
  /* Utan överlapp (Daris 5 okt kväll). Mellan två heltal, t.ex. 67,5 = nästa storlek. */
  var table=[['S',62,67],['M',68,75],['L',76,81],['XL',82,89],['2XL',90,99],['3XL',100,112]];
  root.querySelector('[data-calc]').addEventListener('click',function(){
    var w=parseFloat(root.querySelector('[data-waist]').value), out=root.querySelector('[data-calc-out]');
    if(!w){out.textContent='Skriv ditt midjemått i cm.';return;}
    if(w>112){out.textContent='Över 112 cm: skriv till oss, så hjälper vi dig.';return;}
    var s='S'; for(var i=0;i<table.length;i++){if(w<=table[i][2]){s=table[i][0];break;}}
    out.textContent='Din storlek: '+s+'. Vi har valt den åt dig.';
    var p=pick.querySelector('[data-size="'+s+'"]'); if(p) p.click();
  });

  /* Fast köpknapp: syns när köpknappen scrollats förbi, köper direkt */
  document.body.classList.add('pdp-has-sticky');
  function updSticky(){
    var past=btn.getBoundingClientRect().bottom<0;
    sticky.classList.toggle('is-on',past); sticky.setAttribute('aria-hidden',past?'false':'true'); sbtn.tabIndex=past?0:-1;
  }
  window.addEventListener('scroll',updSticky,{passive:true}); window.addEventListener('resize',updSticky); updSticky();
  document.addEventListener('click',function(e){var a=e.target.closest('a[href="#kop"]');if(!a)return;e.preventDefault();root.querySelector('[data-bundles]').scrollIntoView({behavior:'smooth',block:'center'});});
})();

/* Rörelse efter Shape Lab (5 okt): roterande rad, mekanismkort i tur och ordning, inglidning vid scroll.
   Tider och kurvor mätta i deras sl-pdp.js / sl-base.css (sidresearch/shapelab-animationer-2026-10-05). */
(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('pdp-js');
  // 1. Roterande rad under köpknappen: var 3,75 s, tonar ut 0,3 s, byter, tonar in; pausar vid hover.
  document.querySelectorAll('[data-trustrot]').forEach(function(box){
    var el=box.querySelector('[data-trustrot-text]'),list=box.querySelector('[data-trustrot-list]'),msgs=[];
    try{msgs=JSON.parse(list.textContent).filter(Boolean);}catch(e){}
    if(reduce||!el||msgs.length<2)return;
    var i=0,paused=false;
    box.addEventListener('mouseenter',function(){paused=true;});box.addEventListener('mouseleave',function(){paused=false;});
    setInterval(function(){if(paused)return;i=(i+1)%msgs.length;el.style.opacity='0';setTimeout(function(){el.textContent=msgs[i];el.style.opacity='1';},300);},3750);
  });
  // 2. Mekanismkorten: ett i taget tänds var 3,5 s, bara när rutnätet syns till minst hälften.
  document.querySelectorAll('[data-walk]').forEach(function(grid){
    var cards=[].slice.call(grid.querySelectorAll('.pdp-mech__card'));if(cards.length<2)return;
    var idx=0,paused=false,timer=null,tap=null;
    function set(i){idx=(i%cards.length+cards.length)%cards.length;cards.forEach(function(c,j){c.classList.toggle('is-active',j===idx);});}
    set(0);
    cards.forEach(function(c,i){
      c.addEventListener('mouseenter',function(){paused=true;set(i);});c.addEventListener('mouseleave',function(){paused=false;});
      c.addEventListener('click',function(){set(i);paused=true;clearTimeout(tap);tap=setTimeout(function(){paused=false;},4000);});
    });
    if(reduce)return;
    function start(){if(!timer)timer=setInterval(function(){if(!paused)set(idx+1);},3500);}
    function stop(){clearInterval(timer);timer=null;}
    if('IntersectionObserver' in window){new IntersectionObserver(function(es){es.forEach(function(e){(e.isIntersecting&&e.intersectionRatio>=.5)?start():stop();});},{threshold:[0,.5,1]}).observe(grid);}else start();
  });
  // 3. Inglidning: rubrik och innehåll i sektionerna under köplådan glider upp 16 px när de kommer in.
  var els=[].slice.call(document.querySelectorAll('.pdp-sec .pdp-wrap > *'));
  if(!els.length)return;
  els.forEach(function(e){e.classList.add('pdp-rv');});
  if(reduce||!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in');});return;}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -10% 0px',threshold:.08});
  els.forEach(function(e){io.observe(e);});
})();
